import React from 'react'

interface TestChatRefreshIconProps {
  className?: string
  width?: number
  height?: number
  color?: string
}

const TestChatRefreshIcon: React.FC<TestChatRefreshIconProps> = ({
  className,
  width = 20,
  height = 20,
  color = 'white',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      className={className}
    >
      <path
        d="M6.36841 7.57849C8.05284 5.3831 11.1981 4.96888 13.3934 6.65331C15.5888 8.33774 16.003 11.4829 14.3186 13.6783C12.6342 15.8737 9.48898 16.2879 7.29359 14.6035C6.23501 13.7913 5.59056 12.6395 5.39582 11.4183M6.36841 7.57849L8.87 7.91906M6.36841 7.57849L6.70898 5.0769"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default TestChatRefreshIcon
